import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TokenizePipe } from './tokenize.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ TokenizePipe ],
    exports: [ TokenizePipe ],
})
export class TokenizePipeModule {}
